import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ObservablesService } from "../observables.service"
import { ExcelService } from "../excel.service"
import { Subject } from "rxjs";
import { _ } from 'underscore';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
@Component({
  selector: 'app-unpaid-invoice-view',
  templateUrl: './unpaid-invoice-view.component.html',
  styleUrls: ['./unpaid-invoice-view.component.scss']
})
export class UnpaidInvoiceViewComponent implements OnInit {
  unpaidInvoices:any=[];
  loggedUserInfo:any=[];
  sum: number=0;
  user_id:any;
  slipSubscribeVariable:any;
  slipObserver:any = new Subject<any>();
  productSubscribeVariable:any;
  productObserver:any = new Subject<any>();
  selectedParty:any=null
  selectedTag:any=null
  selectedRangeDates:any=[];
  _selectedClient:any;
  invoiceSlipStatus:boolean = true;
  sortStatus:boolean = false;
  displayedColumns: string[] = ['invoice_date', 'business_name' ,'total_amount', 'actions'];
  unpaidInvoicesData:MatTableDataSource<any>;
   @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() set selectedLastClient(selectedClient){

    this._selectedClient =  selectedClient;
  }

@Input() set selectedClient(selectedClient){
  // console.log("selectedClient==",selectedClient)
  this._selectedClient =  selectedClient;

}

@Input() set selectedData(selectedData){
  // console.log("party  date selected==",selectedData)
  if(selectedData === undefined){
  }else{
    this.selectedRangeDates = selectedData.selectedDates;
    this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null
    this.selectedTag = (selectedData.selectedTag)?selectedData.selectedTag.id:null
    if(this.selectedParty || this.selectedTag){

      if(this.selectedParty && this.selectedTag){
        this.getInvoices(false,true,true)
      }else if(this.selectedParty && !this.selectedTag){
        this.getInvoices(false,true,false)
      }else if(!this.selectedParty && this.selectedTag){
        this.getInvoices(false,false,true)
      }else{
        this.getInvoices(false)
      }

    }else if(!this.selectedParty || !this.selectedTag){
      if(!_.isEmpty(this._selectedClient)){
        this.getInvoices(true)
      }else{
        this.getInvoices(false)
      }
    }

  }
}

getInvoices(client_status=false,party_status=false,tag_status=false){
  this.api.getLoggedUserInfo().then((res:any)=>{
    if(res.data.length > 0){
      this.loggedUserInfo = res.data[0];
      let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
      let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

      let conditions:any;
      let fields:any;
      let joins:any;
      if(client_status){
        joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
        conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
      }else{

        if(party_status && tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};
        }else if(party_status && !tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id};
        }else if(!party_status && tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};

        }else if(!party_status && !tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
        }
      }


      this.api.send("findDb",{
        fields:["I.*,I.party_name as busi_name, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
        table:"master_invoices as I",
        joins:joins,
        conditions:[conditions],
        order:"I.id DESC"
      }).then((res:any)=>{

        this.unpaidInvoices=res.data;
        // console.log("unpaidInvoices==",this.unpaidInvoices)
        this.unpaidInvoicesData = new MatTableDataSource(this.unpaidInvoices);
        this.unpaidInvoicesData.sort = this.sort;
      })

    }else{
      this.api.logOut()
    }
  })
}


  constructor(private excelService:ExcelService, private datePipe:DatePipe, private formBuilder: FormBuilder, private api:ApiService, private router: Router, private observables:ObservablesService) { }


  ngOnInit() {

      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
        }else{
          this.api.logOut()
        }
      })
  }

  exportAsXLSX():void {

      let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
      let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

      let conditions:any;
      let fields:any;
      let joins:any;

      if(!_.isEmpty(this._selectedClient)){
        joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
        conditions = {"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
      }else{

        if(this.selectedParty || this.selectedTag){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};
        }else if(this.selectedParty && !this.selectedTag){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id};
        }else if(!this.selectedParty && this.selectedTag){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};

        }else if(!this.selectedParty && !this.selectedTag){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
        }
      }

      this.api.send("findDb",{
        fields:["I.*,I.party_name as busi_name, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
        table:"master_invoices as I",
        joins:joins,
        conditions:[conditions],
        order:"I.id DESC"
      }).then((res:any)=>{

        this.iterateData(res.data).then((invoiceData:any)=>{
          // console.log("response for popup-",invoiceData)
          this.excelService.exportAsExcelFile(invoiceData, 'invoice');

        })
      })

  }

  iterateData(data){
    return new Promise((resolve)=>{
      let a = 0
      let invoiceData:any=[]
      let number = 0

      // console.log("data==",data)

      this.slipSubscribeVariable = this.slipObserver.subscribe((a)=>{
        if(a>=data.length){
          this.slipSubscribeVariable.unsubscribe()
          resolve(invoiceData)
        }else{
          if(data[a].slip_status && data[a].direct_invoice_status == 0){

            this.api.send("findDb",{
              table:"master_slip_products",
              conditions:[{master_invoice_id:data[a].id}]
            }).then((res:any)=>{
              if(res.data.length > 0){

                let groups = _.groupBy(res.data,"category_id")
                // console.log("master slip value==",_.values(groups));
                let values =_.values(groups)


                invoiceData.push({
                     "Invoice Date":this.datePipe.transform(data[a].invoice_date, 'dd-MM-yyyy'),
                     "Invoice Number":data[a].invoice_number,
                     "Business Name":data[a].business_name,
                     "Party Name":data[a].party_name,
                     "GSTIN":data[a].gstin,
                     "Taxable Amount":data[a].gst_total_amount,
                     "Paid Amount":data[a].paid_amt,
                     "Balance Amount":data[a].balance,
                     "Invoice Amount(Ex. GST)":data[a].exclude_gst_total_amount,
                     "Invoice Amount(In. GST)":data[a].total_amount,

                   })
                for(let i=0;i<values.length;i++){
                  invoiceData.push({"Category Name":values[i][0].category_name})

                  for(let j=0;j<values[i].length;j++){
                    invoiceData.push({
                      "Item Name":values[i][j].item_name,
                      "Item description":values[i][j].item_description,
                      "Col_1_unit_variable":values[i][j].col_1,
                      "Col_1_unit_variable_value":values[i][j].col_1_value,
                      "Col_2_unit_variable":values[i][j].col_2,
                      "Col_2_unit_variable_value":values[i][j].col_2_value,
                      "Col_3_unit_variable":values[i][j].col_3,
                      "Col_3_unit_variable_value":values[i][j].col_3_value,
                      "Unit":values[i][j].unit,
                      "Unit Value":values[i][j].unit_value,
                      "Rate":values[i][j].rate,
                      "Discount":values[i][j].discount,
                      "Grass Amount":values[i][j].grass_amount,
                      "SGST":values[i][j].sgst,
                      "CGST":values[i][j].cgst,
                      "IGST":values[i][j].igst,
                      "Net Amount":values[i][j].net_amount
                    })

                    if((i == values.length - 1) && (j == values[i].length-1)){
                      // console.log("i==",i)
                      // console.log("j==",j)
                      this.slipObserver.next(a+1)
                    }
                  }
                }
              }else{
                // console.log("--------------------------------No Slip product---",data[a].id)
                invoiceData.push({
                     "Invoice Date":this.datePipe.transform(data[a].invoice_date, 'dd-MM-yyyy'),
                     "Invoice Number":data[a].invoice_number,
                     "Business Name":data[a].business_name,
                     "Party Name":data[a].party_name,
                     "GSTIN":data[a].gstin,
                     "Taxable Amount":data[a].gst_total_amount,
                     "Paid Amount":data[a].paid_amt,
                     "Balance Amount":data[a].balance,
                     "Invoice Amount(Ex. GST)":data[a].exclude_gst_total_amount,
                     "Invoice Amount(In. GST)":data[a].total_amount,
                     "Category Name":"-----No Slip Product-----"

                   })

                this.slipObserver.next(a+1)
              }

            })
          }else if(data[a].slip_status == 0 && data[a].direct_invoice_status == 0){
            this.api.send("findDb",{
              table:"master_invoice_products",
              conditions:[{master_invoice_id:data[a].id}]
            }).then((res:any)=>{
              if(res.data.length > 0){

                let groups = _.groupBy(res.data,"category_id")
                console.log("master invoice value==",_.values(groups));
                let values =_.values(groups)
                invoiceData.push({
                     "Invoice Date":this.datePipe.transform(data[a].invoice_date, 'dd-MM-yyyy'),
                     "Invoice Number":data[a].invoice_number,
                     "Business Name":data[a].business_name,
                     "Party Name":data[a].party_name,
                     "GSTIN":data[a].gstin,
                     "Taxable Amount":data[a].gst_total_amount,
                     "Paid Amount":data[a].paid_amt,
                     "Balance Amount":data[a].balance,
                     "Invoice Amount(Ex. GST)":data[a].exclude_gst_total_amount,
                     "Invoice Amount(In. GST)":data[a].total_amount,

                   })
                for(let i=0;i<values.length;i++){
                  invoiceData.push({"Category Name":values[i][0].category_name})

                  for(let j=0;j<values[i].length;j++){
                    invoiceData.push({
                      "Item Name":values[i][j].item_name,
                      "Item description":values[i][j].item_description,
                      "Col_1_unit_variable":values[i][j].col_1,
                      "Col_1_unit_variable_value":values[i][j].col_1_value,
                      "Col_2_unit_variable":values[i][j].col_2,
                      "Col_2_unit_variable_value":values[i][j].col_2_value,
                      "Col_3_unit_variable":values[i][j].col_3,
                      "Col_3_unit_variable_value":values[i][j].col_3_value,
                      "Unit":values[i][j].unit,
                      "Unit Value":values[i][j].unit_value,
                      "HSN Code":values[i][j].hsn_code,
                      "Rate":values[i][j].rate,
                      "Discount":values[i][j].discount,
                      "Grass Amount":values[i][j].grass_amount,
                      "SGST":values[i][j].sgst,
                      "CGST":values[i][j].cgst,
                      "IGST":values[i][j].igst,
                      "Net Amount":values[i][j].net_amount
                    })

                    if((i == values.length - 1) && (j == values[i].length-1)){
                      // console.log("i==",i)
                      // console.log("j==",j)
                      this.slipObserver.next(a+1)
                    }
                  }
                }
              }else{
                // console.log("--------------------------------No invoice product---",data[a].id)
                invoiceData.push({
                     "Invoice Date":this.datePipe.transform(data[a].invoice_date, 'dd-MM-yyyy'),
                     "Invoice Number":data[a].invoice_number,
                     "Business Name":data[a].business_name,
                     "Party Name":data[a].party_name,
                     "GSTIN":data[a].gstin,
                     "Taxable Amount":data[a].gst_total_amount,
                     "Paid Amount":data[a].paid_amt,
                     "Balance Amount":data[a].balance,
                     "Invoice Amount(Ex. GST)":data[a].exclude_gst_total_amount,
                     "Invoice Amount(In. GST)":data[a].total_amount,
                     "Category Name":"-----No Invoice Product-----"

                   })

                this.slipObserver.next(a+1)
              }

            })
          }else{

            // console.log("--------------------------------Direct Invoice---",data[a].id)
            invoiceData.push({
                 "Invoice Date":this.datePipe.transform(data[a].invoice_date, 'dd-MM-yyyy'),
                 "Invoice Number":data[a].invoice_number,
                 "Business Name":data[a].business_name,
                 "Party Name":data[a].party_name,
                 "GSTIN":data[a].gstin,
                 "Taxable Amount":data[a].gst_total_amount,
                 "Paid Amount":data[a].paid_amt,
                 "Balance Amount":data[a].balance,
                 "Invoice Amount(Ex. GST)":data[a].exclude_gst_total_amount,
                 "Invoice Amount(In. GST)":data[a].total_amount,

               })

                 this.slipObserver.next(a+1)
          }
        }
      })

      this.slipObserver.next(a)
    })
  }

  checkState(invoiceData){

    if(invoiceData.gstin.length > 0){
      if(this.loggedUserInfo.gstin.substring(0,2) == invoiceData.gstin.substring(0,2)){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }


getData(data,invoiceData){
  // console.log("data=",data);
    return new Promise((resolve)=>{
      let a = 0
      this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
        if(a>=data.length){
          this.productSubscribeVariable.unsubscribe();
          resolve(data)
        }else{
            this.api.send("findDb",{
              fields:["PD.rate as product_rate,PD.*,I.*"],
              table:"product_details as PD",
              joins:[{
                type:"left",
                table:"items as I",
                conditions:["I.id = PD.item_id"]
              }],
              conditions:[{
                "PD.invoice_id" :data[a].invoice_id,"PD.slip_id":data[a].slip_id
              }],
              order:"PD.id ASC"
            }).then((result2:any)=>{
              if(result2.data.length > 0){

                let gstTotalAmount = 0;
                 gstTotalAmount = result2.data.reduce( ( accumulator, currentValue ) => {

                    return accumulator + (currentValue.amount*currentValue.percentage)/100;

                  }, 0);
                  // console.log('gstTotalAmount=',gstTotalAmount)

                this.productObserver.next(a+1);
              }else{
                this.productObserver.next(a+1);
              }
            })


        }
      })

      this.productObserver.next(a);
    })
  }


  getAdminInfo(id){
    return new Promise((resolve,reject)=>{
       this.api.send("findDb",{
         table:"users",
         conditions:[{id:id, role:'admin'}]
       }).then((userRes:any)=>{
         if(userRes.data.length > 0){

           resolve({status:true,userData:userRes.data[0]})
         }else{
           resolve({status:false})
         }
       })

    })
  }

  showInvoice(invoiceData){
    // console.log("invoice data==",invoiceData)
    this.observables.invoiceViewStatus.next({id:invoiceData.id,invoiceData:invoiceData})
  }


  totalAmount(){
    return this.unpaidInvoices.reduce( ( accumulator, currentValue ) => {
      return accumulator + parseFloat(currentValue.balance);
    }, 0);
  }

  // getAllInvoices(allStatus = false){
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //   let conditions:any;
  //   if(allStatus){
  //     conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
  //   }else{
  //     conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[conditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //     this.unpaidInvoices=res.data;
  //   })
  // }

  // getDatewiseInvoices(specific_status=false,allStatus = false){
  //   // console.log("selected date ranges=",this.selectedRangeDates)
  //
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //   let conditions:any;
  //   if(specific_status && !allStatus){
  //     conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id};
  //   }else if(specific_status && allStatus){
  //
  //     conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.business_id":this.loggedUserInfo.business_id};
  //   }
  //   else{
  //     conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id}
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[conditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //     this.unpaidInvoices=res.data;
  //
  //   })
  //
  // }


  gotoUnpaid(unpaidData){
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/unpaid-invoice')],{ state: { data: unpaidData} });

  }



  backToSlip(invoiceData,index){
    if(confirm("Are you sure about moving invoice no: "+invoiceData.invoice_number+" to Slips ?")){

      this.api.send("updateDb",{
        table:"master_slips",
        data:{
          invoice_status:0,
          master_invoice_id:null
        },
        conditions:[{master_invoice_id:invoiceData.id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          if(invoiceData.direct_invoice_status == 1){
            this.api.send("deleteDb",{
              table:"master_invoices",
              conditions:[{id:invoiceData.id}]
            }).then((deleteInvoiceRes:any)=>{
              if(deleteInvoiceRes.data.affectedRows){
                this.observables.showToastMessage({type:0,message:"Invoice Moved to Slip List."})
                this.unpaidInvoices.splice(index, 1);
                this.unpaidInvoicesData = new MatTableDataSource(this.unpaidInvoices);
                this.unpaidInvoicesData.sort = this.sort;
                this.observables.refreshSlipListStatus.next()
              }else{

                this.observables.showToastMessage({type:1,message:"Can\'t move to Slip List, Try again "})
              }
            })
          }else{

            this.updateSlipDetails(invoiceData.id).then((updateProductStatus:any)=>{
              if(updateProductStatus){

                this.api.send("deleteDb",{
                  table:"master_invoices",
                  conditions:[{id:invoiceData.id}]
                }).then((deleteInvoiceRes:any)=>{
                  if(deleteInvoiceRes.data.affectedRows){
                    this.observables.showToastMessage({type:0,message:"Invoice Moved to Slip List."})
                    this.unpaidInvoices.splice(index, 1);
                    this.unpaidInvoicesData = new MatTableDataSource(this.unpaidInvoices);
                    this.unpaidInvoicesData.sort = this.sort;
                    this.observables.refreshSlipListStatus.next()
                  }else{

                    this.observables.showToastMessage({type:1,message:"Can\'t move to Slip List, Try again "})
                  }
                })
              }else{

                this.api.send("updateDb",{
                  table:"master_slips",
                  data:{
                    invoice_status:1,
                    master_invoice_id:invoiceData.id
                  },
                  conditions:[{invoice_id:invoiceData.id}]
                }).then((result1:any)=>{
                  if(result1.data.affectedRows){

                    this.observables.showToastMessage({type:1,message:"Can\'t move to Slip List, Try again "})
                  }else{
                    this.observables.showToastMessage({type:1,message:"Can\'t move to Slip List, Try again "})
                  }
                })
              }
            })
          }

        }else{
          this.observables.showToastMessage({type:1,message:"Can\'t move to Slip List, Try again "})
        }
      })
    }
  }

  updateSlipDetails(invoice_id){
    return new Promise((resolve)=>{

      this.api.send("updateDb",{
        table:"master_slip_products",
        data:{
          master_invoice_id:null
        },
        conditions:[{master_invoice_id:invoice_id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){

          resolve(true);
        }else{
          resolve(false);
        }
      })
    })
  }

  editInvoice(unpaidInvoice){
     this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/edit-invoice')],{ state: { data: unpaidInvoice, editStatus:true} });
  }

  deleteInvoice(unpaidInvoice,index){
    if(confirm("Are you sure to Delete Invoice No: "+unpaidInvoice.invoice_number +"?")){
      this.api.send("updateDb",{
        table:"master_invoices",
        data:{
          delete_status:1
        },
        conditions:[{id:unpaidInvoice.id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){
          this.observables.showToastMessage({type:0,message:"Invoice Deleted Successfully."})
          this.unpaidInvoices.splice(index, 1);
          // this.refreshInvoiceList()
          this.unpaidInvoicesData = new MatTableDataSource(this.unpaidInvoices);
          this.unpaidInvoicesData.sort = this.sort;
        }else{

          this.observables.showToastMessage({type:1,message:"Can\'t Delete Invoice. Try again.."})
        }
      })
    }
  }

  // refreshInvoiceList(){
  //   if(!this.selectedParty){
  //
  //     this.getAllInvoices()
  //   }else{
  //
  //     this.getDatewiseInvoices()
  //   }
  // }


  sortByDueDate(){
    this.sortStatus = !this.sortStatus;
    this.sortInvocies();

  }



  sortInvocies(){
    if(this.sortStatus){
      this.unpaidInvoices.sort(function(a, b) {
          var dateA:any = new Date(a.invoice_date);
          var dateB:any = new Date(b.invoice_date);
          return dateA - dateB;
      });
    }else{
      this.unpaidInvoices.sort(function(a, b) {
          var dateA:any = new Date(a.invoice_date);
          var dateB:any = new Date(b.invoice_date);
          return dateB - dateA;
      });
    }
  }
}
